type GlobalStore = { dispatch: (action: any) => void }

/** `index.tsx` assigns `store` to `globalThis` at startup. */
export function getGlobalStore(): GlobalStore {
    return (globalThis as typeof globalThis & { store: GlobalStore }).store
}
